import axios from "axios";
import { Guid } from "js-guid";
import {
  BookOpen,
  DatabaseZap,
  ExternalLink,
  History,
  MessageCircle,
  MessageSquarePlus,
  MoreVertical,
  PinOff,
  Podcast,
  UploadCloud,
  User,
  X,
  Pin,
} from "lucide-react";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import MomentumAILogo from "../Assets/Images/Momentum AI Icon-color.png";
import SupportLoader from "../CommonControls/SupportLoader";
import CommonValues from "./Utils";

export default function Header({
  setShowConversationHistory,
  chatBotEmbeded,
  onClose,
  onFreshDeskClick,
  onPinToggleClick,
  isPinned,
}: any) {
  const navigate = useNavigate();
  const toast: any = useRef("");
  const dropdownRef = useRef<HTMLDivElement>(null);

  const [businessName, setBusinessName] = useState<string | null>("");
  const [isChatBotPage, setIsChatBotPage] = useState(false);
  const [isPolicyComparePage, setIsPolicyComparePage] = useState(false);
  const [isTalkToAMSPage, setIsTalkToAMSPage] = useState(false);
  const [isTalkToDatabasePage, setIsTalkToDatabasePage] = useState(false);
  const [isInsuredContextChatPage, setIsInsuredContextChatPage] = useState(false);
  const [isPolicyContextChatPage, setIsPolicyContextChatPage] = useState(false);
  const [isAgentsPage, setIsAgentsPage] = useState(false);
  const [isXMLAgentPage, setIsXMLAgentPage] = useState(false);
  const [isNeo4jAgentPage, setIsNeo4jAgentPage] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showNCSupportFeedbackBox, setShowNCSupportFeedbackBox] = useState(false);
  const [showNCSupportTrainingContentBox, setShowNCSupportTrainingContentBox] = useState(false);
  const [showTalkToAMSRequestBox, setShowTalkToAMSRequestBox] = useState(false);
  const [submitFeedbackLoading, setSubmitFeedbackLoading] = useState(false);
  const [submitTrainingContentLoading, setSubmitTrainingContentLoading] = useState(false);
  const [submitRequestLoading, setSubmitRequestLoading] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [trainingContent, setTrainingContent] = useState("");

  const roleId = localStorage.getItem("RoleId");
  const [isTalkToAMSEnabled, setIsTalkToAMSEnabled] = useState<boolean>(
    localStorage.getItem("IsTalkToAMSEnabled") === "true"
  );
  const [isTalkToAMSRequested, setIsTalkToAMSRequested] = useState<boolean>(
    localStorage.getItem("IsTalkToAMSRequested") === "true"
  );

  useEffect(() => {
    setBusinessName(localStorage.getItem("BusinessName"));
    setIsChatBotPage(
      window.location.pathname.substring(0, 4) === "/bot" ||
      window.location.pathname === "/upload"
    );
    setIsPolicyComparePage(window.location.pathname === "/policy");
    setIsTalkToAMSPage(window.location.pathname.startsWith("/talktoams"));
    setIsTalkToDatabasePage(
      window.location.pathname.startsWith("/talk-to-database")
    );
    setIsXMLAgentPage(window.location.pathname.startsWith("/xml"));
    setIsNeo4jAgentPage(window.location.pathname.startsWith("/neo4j"));
    setIsAgentsPage(window.location.pathname === "/agents");
    setIsInsuredContextChatPage(
      window.location.pathname.startsWith("/insured/context-chat")
    );
    setIsPolicyContextChatPage(
      window.location.pathname.startsWith("/policy/context-chat")
    );
  }, []);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const onLogoClick = () => {
    if (window.location.pathname.substring(0, 4) === "/bot") {
      setShowConversationHistory(false);
    }
    let conversationId = Guid.newGuid();
    chatBotEmbeded
      ? navigate(`/bot/${conversationId}/embeded`)
      : navigate(`/bot/${conversationId}`);
  };

  const onLogoutClick = () => {
    CommonValues.Logout(navigate);
  };

  const onHistoryClick = () => {
    setShowConversationHistory(true);
    setShowDropdown(false);
  };

  const onOpenInMomentumAICenterClick = () => {
    window.open(
      `${window.location.ancestorOrigins[0]}/AMSINS/AI/LandingPreview?chat=true`,
      "_blank"
    );
    setShowDropdown(false);
  };

  const onStartNewConversation = () => {
    if (window.location.pathname.startsWith("/bot")) {
      setShowConversationHistory(false);
      chatBotEmbeded
        ? navigate(`/bot/${Guid.newGuid()}/embeded`)
        : navigate(`/bot/${Guid.newGuid()}`);
    } else if (window.location.pathname.startsWith("/talktoams")) {
      setShowConversationHistory(false);
      chatBotEmbeded
        ? navigate(`/talktoams/${Guid.newGuid()}/embeded`)
        : navigate(`/talktoams/${Guid.newGuid()}`);
    } else if (window.location.pathname.startsWith("/xml")) {
      setShowConversationHistory(false);
      chatBotEmbeded
        ? navigate(`/xml/${Guid.newGuid()}/embeded`)
        : navigate(`/xml/${Guid.newGuid()}`);
    } else if (window.location.pathname.startsWith("/neo4j")) {
      setShowConversationHistory(false);
      chatBotEmbeded
        ? navigate(`/neo4j/${Guid.newGuid()}/embeded`)
        : navigate(`/neo4j/${Guid.newGuid()}`);
    } else if (window.location.pathname.startsWith("/insured/context-chat")) {
      setShowConversationHistory(false);
      chatBotEmbeded
        ? navigate(`/insured/context-chat/${Guid.newGuid()}/embeded`)
        : navigate(`/insured/context-chat/${Guid.newGuid()}`);
    } else if (window.location.pathname.startsWith("/policy/context-chat")) {
      setShowConversationHistory(false);
      chatBotEmbeded
        ? navigate(`/policy/context-chat/${Guid.newGuid()}/embeded`)
        : navigate(`/policy/context-chat/${Guid.newGuid()}`);
    }
    setShowDropdown(false);
  };

  const onSupportAssistantClick = () => {
    chatBotEmbeded
      ? navigate(`/bot/${Guid.newGuid()}/embeded`)
      : navigate(`/bot/${Guid.newGuid()}`);
    setShowDropdown(false);
  };

  const onTalkToAMSClick = () => {
    if (isTalkToAMSEnabled) {
      chatBotEmbeded
        ? navigate(`/talktoams/${Guid.newGuid()}/embeded`)
        : navigate(`/talktoams/${Guid.newGuid()}`);
    } else {
      setShowTalkToAMSRequestBox(true);
    }
    setShowDropdown(false);
  };


  const onTalkToDatabaseClick = () => {
    chatBotEmbeded
      ? navigate(`/talk-to-database/${Guid.newGuid()}/embeded`)
      : navigate(`/talk-to-database/${Guid.newGuid()}`);
    setShowDropdown(false);
  };

  const onFeedbackClick = () => {
    setShowNCSupportFeedbackBox(true);
    setShowDropdown(false);
  };

  const onTrainingContentClick = () => {
    setShowNCSupportTrainingContentBox(true);
    setShowDropdown(false);
  };

  const onUploadClick = () => {
    navigate("/upload");
    setShowDropdown(false);
  };

  // Dialog handlers remain the same...
  const onHide = () => {
    setShowNCSupportFeedbackBox(false);
    setShowNCSupportTrainingContentBox(false);
    setShowTalkToAMSRequestBox(false);
  };

  const onFeedbackChange = (feedback: string) => {
    setFeedback(feedback);
  };

  const onTrainingContentChange = (trainingContent: string) => {
    setTrainingContent(trainingContent);
  };

  const onSubmitFeedback = () => {
    setSubmitFeedbackLoading(true);
    const token = CommonValues.GetToken();
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_NcSupport_Url}/api/ncsupportbot/nc-support-feedback`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: JSON.stringify({
        Feedback: feedback,
        PageRoute: window.location.pathname,
      }),
    };

    axios(config)
      .then((response: any) => {
        setSubmitFeedbackLoading(false);
        toast.current.show({
          severity: "success",
          detail: "Feedback submitted successfully.",
          life: 3000,
        });
        setFeedback("");
        setShowNCSupportFeedbackBox(false);
      })
      .catch((error: any) => {
        setSubmitFeedbackLoading(false);
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else {
            toast.current.show({
              severity: "error",
              detail: `Error occurred while submitting Feedback.`,
              life: 3000,
            });
          }
        }
      });
  };

  const onSubmitRequest = () => {
    setSubmitRequestLoading(true);
    const token = CommonValues.GetToken();
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_NcSupport_Url}/api/nctalktoamsagent/nc-talk-to-ams-subscription-request`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then((response: any) => {
        setSubmitRequestLoading(false);
        toast.current.show({
          severity: "success",
          detail: "Talk To Database request submitted successfully.",
          life: 3000,
        });
        setFeedback("");
        setShowTalkToAMSRequestBox(false);
        setIsTalkToAMSRequested(true);
        localStorage.setItem("IsTalkToAMSRequested", "true");
      })
      .catch((error: any) => {
        setSubmitRequestLoading(false);
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else {
            toast.current.show({
              severity: "error",
              detail: `Error occurred while submitting request.`,
              life: 3000,
            });
          }
        }
      });
  };

  const onSubmitTrainingContent = () => {
    setSubmitTrainingContentLoading(true);
    const token = CommonValues.GetToken();
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_NcSupport_Url}/api/ncsupportbot/nc-support-training`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: JSON.stringify({
        TrainingData: trainingContent,
        PageRoute: window.location.pathname,
      }),
    };

    axios(config)
      .then((response: any) => {
        setSubmitTrainingContentLoading(false);
        toast.current.show({
          severity: "success",
          detail: "Training content submitted successfully. The bot will be trained soon.",
          life: 3000,
        });
        setTrainingContent("");
        setShowNCSupportTrainingContentBox(false);
      })
      .catch((error: any) => {
        setSubmitTrainingContentLoading(false);
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else {
            toast.current.show({
              severity: "error",
              detail: `Error occurred while submitting training content.`,
              life: 3000,
            });
          }
        }
      });
  };

  // const onFreshDeskClick = () => {
  //   const parentOrigin = window.location.ancestorOrigins[0];
  //   if (!parentOrigin) {
  //       console.error("Cannot determine parent origin for postMessage.");
  //       return;
  //   }
  //   const availableCount = 1; 
  //   window.parent.postMessage(
  //     {
  //       type: "showFreshChat",
  //       payload: { count: availableCount },
  //     },
  //     parentOrigin
  //   );
  // };

  return (
    <>
      <Toast ref={toast} />
      <div className="ql-cs-header-container">
        <div className="ql-cs-header-content">

          <div className="ql-cs-logo-section">
            {chatBotEmbeded ? (
              <div onClick={onLogoClick} className="ql-cs-logo-wrapper">
                <img src={MomentumAILogo} className="ql-cs-logo-image" alt="Logo" />
                <span className="ql-cs-title">
                  {isTalkToDatabasePage ? (
                    "Talk To Activity History"
                  ) : isTalkToAMSPage ? (
                    "Talk To Database"
                  ) : isInsuredContextChatPage || isPolicyContextChatPage ? (
                    "Momentum AI"
                  ) : (
                    ""
                  )}
                </span>
              </div>
            ) : (
              <div className="ql-cs-logo-wrapper">
                <img
                  src={MomentumAILogo}
                  className="ql-cs-logo-image"
                  onClick={onLogoClick}
                  alt="MomentumAILogo"
                />
                <span className="ql-cs-title">
                  {isChatBotPage
                    ? "Support Chat Bot"
                    : isPolicyComparePage
                      ? "| Policy Comparison"
                      : isTalkToAMSPage
                        ? "| Talk To Database"
                        : isAgentsPage
                          ? "| Agents"
                          : isXMLAgentPage
                            ? "| XML Agent"
                            : isNeo4jAgentPage
                              ? "| Neo4j Agent"
                              : ""}
                </span>
              </div>
            )}
          </div>

          <div className="ql-cs-actions-section">
            {chatBotEmbeded && (
              <>
                <button
                  className="ql-cs-action-btn ql-cs-btn-primary "
                  onClick={onFreshDeskClick}
                  title="Chat with a human"
                >
                  <User size={18} />
                  <span className="ql-cs-btn-text">Fresh Desk</span>
                </button>
                
                <button
                  className="ql-cs-action-btn ql-cs-btn-primary"
                  onClick={onPinToggleClick}
                  title={isPinned ? "Unpin" : "Pin"}
                >
                  {isPinned ? <PinOff size={18} /> : <Pin size={18} />}
                </button>

                <button
                  className="ql-cs-action-btn ql-cs-btn-primary "
                  onClick={onStartNewConversation}
                  title="Start New Conversation"
                >
                  <MessageSquarePlus size={18} />
                  <span className="ql-cs-btn-text">New Chat</span>
                </button>
                {!isInsuredContextChatPage && !isPolicyContextChatPage && <button
                  className="ql-cs-action-btn ql-cs-btn-primary"
                  onClick={onHistoryClick}
                  title="View Conversation History"
                >
                  <History size={18} />
                  <span className="ql-cs-btn-text">History</span>
                </button>}


                <button
                  className="ql-cs-action-btn ql-cs-btn-primary "
                  onClick={onOpenInMomentumAICenterClick}
                  title="Open in Momentum AI Center"
                >
                  <ExternalLink size={18} />
                  <span className="ql-cs-btn-text">Open</span>
                </button>

                <div className="ql-cs-dropdown-wrapper" ref={dropdownRef}>
                  <button
                    className="ql-cs-action-btn ql-cs-btn-primary "
                    onClick={() => setShowDropdown(!showDropdown)}
                    title="More Options"
                  >
                    <MoreVertical size={18} />
                  </button>

                  {showDropdown && (
                    <div className="ql-cs-dropdown-menu">
                      <div className="ql-cs-dropdown-item" onClick={onFeedbackClick}>
                        <MessageCircle size={16} />
                        <span>Feedback</span>
                      </div>

                      {(isInsuredContextChatPage || isPolicyContextChatPage) && <div className="ql-cs-dropdown-item" onClick={onSupportAssistantClick}>
                        <User size={16} />
                        <span>Support Assistant</span>
                      </div>}

                      <div className="ql-cs-dropdown-item" onClick={onTalkToAMSClick}>
                        <Podcast size={16} />
                        <span>Talk To Database</span>
                      </div>

                      {/* <div className="ql-cs-dropdown-item" onClick={onTalkToDatabaseClick}>
                        <DatabaseZap size={16} />
                        <span>Talk To Activity History</span>
                      </div> */}

                      {isChatBotPage && (
                        <div className="ql-cs-dropdown-item" onClick={onTrainingContentClick}>
                          <BookOpen size={16} />
                          <span>Training Content</span>
                        </div>
                      )}

                      {roleId === "1" && !(window.location.pathname === "/upload") && (
                        <div className="ql-cs-dropdown-item" onClick={onUploadClick}>
                          <UploadCloud size={16} />
                          <span>Upload</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {onClose && (
                  <button
                    className="ql-cs-action-btn ql-cs-btn-primary "
                    onClick={onClose}
                    title="Close Chat"
                  >
                    <X size={18} />
                  </button>
                )}
              </>
            )}

            {!chatBotEmbeded && CommonValues.GetToken() != null && (
              <div className="ql-cs-user-section">
                <span className="ql-cs-welcome-text">
                  Welcome <strong>{businessName}</strong>
                </span>
                <button
                  className="ql-cs-logout-btn"
                  onClick={onLogoutClick}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <Dialog
        visible={showNCSupportFeedbackBox}
        className="nc-sidebar-dialog-box"
        header={
          <div className={`${chatBotEmbeded ? "text-14" : "text-16"}`}>
            Your feedback will improve this product
          </div>
        }
        onHide={() => onHide()}
        style={{ width: `${chatBotEmbeded ? "83vw" : "25vw"}` }}
        draggable={false}
      >
        <div className="row mt-1">
          <div className="col-md-12">
            <textarea
              name="feedback"
              onChange={(e) => onFeedbackChange(e.target.value)}
              value={feedback}
              className={`form-control mb-3 nc-support-text-area ${chatBotEmbeded ? "text-14" : "text-16"
                }`}
              rows={4}
              placeholder=""
              autoFocus={true}
            />
          </div>
          <div className="col-md-12 text-end">
            {submitFeedbackLoading ? (
              <div className="d-flex justify-content-end">
                <SupportLoader />
              </div>
            ) : (
              <button
                title="Submit you feedback"
                onClick={onSubmitFeedback}
                className="btn feedback-btn"
              >
                <div className={`${chatBotEmbeded ? "text-14" : "text-16"}`}>
                  Submit
                </div>
              </button>
            )}
          </div>
        </div>
      </Dialog>

      <Dialog
        visible={showNCSupportTrainingContentBox}
        className="nc-sidebar-dialog-box"
        header={
          <div className={`${chatBotEmbeded ? "text-14" : "text-16"}`}>
            Your training content will improve this product
          </div>
        }
        style={{ width: `${chatBotEmbeded ? "83vw" : "50vw"}` }}
        onHide={() => onHide()}
        draggable={false}
      >
        <div className="row mt-1">
          <div className="col-md-12">
            <textarea
              name="Training content"
              onChange={(e) => onTrainingContentChange(e.target.value)}
              value={trainingContent}
              className={`form-control mb-3 nc-support-text-area ${chatBotEmbeded ? "text-14" : "text-16"
                }`}
              rows={chatBotEmbeded ? 25 : 15}
              placeholder="Enter data for training..."
              autoFocus={true}
            />
          </div>
          <div className="col-md-12 text-end">
            {submitTrainingContentLoading ? (
              <div className="d-flex justify-content-end">
                <SupportLoader />
              </div>
            ) : (
              <button
                title="Submit you training content"
                onClick={onSubmitTrainingContent}
                className="btn submit-btn"
              >
                <div className={`${chatBotEmbeded ? "text-14" : "text-16"}`}>
                  Submit
                </div>
              </button>
            )}
          </div>
        </div>
      </Dialog>

      <Dialog
        visible={showTalkToAMSRequestBox}
        className="nc-sidebar-dialog-box"
        header={
          <div className={`${chatBotEmbeded ? "text-14" : "text-16"}`}>
            {isTalkToAMSRequested
              ? "Talk To Database is requested by your agency"
              : "Would you like to request Talk To Database?"}
          </div>
        }
        onHide={() => onHide()}
        style={{ width: `${chatBotEmbeded ? "83vw" : "25vw"}` }}
        draggable={false}
      >
        <div className="row">
          {isTalkToAMSRequested ? (
            <span className="text-12">
              Please contact admin for further updates.
            </span>
          ) : (
            <div className="text-center">
              {submitRequestLoading ? (
                <div className="d-flex justify-content-center">
                  <SupportLoader />
                </div>
              ) : (
                <button
                  title="Submit you feedback"
                  onClick={onSubmitRequest}
                  className="btn submit-btn w-50"
                >
                  <div className={`${chatBotEmbeded ? "text-14" : "text-16"}`}>
                    Submit Request
                  </div>
                </button>
              )}
            </div>
          )}
        </div>
      </Dialog>
    </>
  );
}
